<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Overview">

        <p>Tasks - including classwork, tests and exams are listed below.</p>
        <p>Task categories are a way to group your tasks for faster sorting and use. You can name your category based on classwork, tests, etc</p>

        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <div class="demo-alignment">
                <router-link to="/task/question/new">
                  <vs-button color="primary" type="line" line-origin="right" :xdisabled="!categories.length">
                    Add Questions
                  </vs-button>
                </router-link>
              <router-link to="/task/quiz/new">
                <vs-button color="primary" type="line" line-origin="right" :xdisabled="!categories.length">
                  Add Quiz
                </vs-button>
              </router-link>
              <vs-button @click="newCategoryPopup=true" color="primary" type="line" line-origin="right">Add Category</vs-button>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <div class="demo-alignment">
              <vs-button type="line" line-origin="right" color="dark" @click="openFilter = true" icon-pack="feather" icon="icon-filter">Filter</vs-button>
            </div>
          </vs-col>
        </vs-row>

    </vx-card>

    <br>

    <vx-card title="Tasks">
      <div slot="no-body" class="mt-4">
        <vs-table :data="task" class="table-dark-inverted stripe">
          <template slot="thead">
            <vs-th>SUBJECT</vs-th>
            <!-- <vs-th>CLASS</vs-th> -->
            <vs-th>TITLE</vs-th>
            <vs-th>TYPE</vs-th>
            <vs-th>QUESTIONS</vs-th>
            <vs-th>DATE</vs-th>
            <vs-th>MORE</vs-th>
          </template>
          <template ssslot-scope="{data}">

            <!-- <vs-tr :key="indextr" v-for="(tr, indextr) in data"> -->
            <vs-tr v-for="t in task" :key="t.id">
              <vs-td :data="t.id">
                <span>{{ subjects[t.subj_id].name }}</span>
                <br>
                <small>
                  <span v-for="(v) in t.class" :key="v">
                    <span class="mb-2">{{ (classes[v]) ? classes[v].short_name : '-' }} &nbsp; </span>
                  </span>
                </small>
              </vs-td>
              <!-- <vs-td :data="t.id">
                <span>{{ classes[t.class_id].short_name }}</span>
              </vs-td> -->
              <vs-td :data="t.id">
                <router-link :to="{ path: `/task/quiz/view/${t.id}` }">
                  <span>{{ t.slug }}</span>
                </router-link>
              </vs-td>
              <vs-td :data="t.id">
                <span>{{ t.type | title }}</span>
              </vs-td>
              <vs-td :data="t.id">
                {{ t.activity }} 
              </vs-td>
              <vs-td :data="t.id">
                <!-- <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + data[indextr].statusColor"></div>{{data[indextr].title}}</span> -->
                {{ t.createdAt | moment("MMM Do, YYYY") }}<br>
                <!-- <small>{{ l.staff_title }} {{ l.first_name }} {{ l.last_name }}</small> -->
              </vs-td>
              <vs-td :data="t.id">
                -
                <!-- <span>{{data[indextr].estDelDate}}</span> -->
              </vs-td>
            </vs-tr>

          </template>
        </vs-table>
      </div>
    </vx-card>

    <br>
    <br>

    <vs-prompt
      title="Filter Tasks"
      @accept="getTasks"
      :active.sync="openFilter">
      <div class="con-exemple-prompt">

        <v-select :options="options.classes" v-model="filter.class" placeholder="Select Class" class="mb-5"  />
        <v-select :options="options.subjects" v-model="filter.subject" placeholder="Select Subject" class="mb-5"  />
        <v-select :options="options.type" v-model="filter.type" placeholder="Select Type" class="mb-5"  />

      </div>
    </vs-prompt>


    <vs-popup class="holamundo" title="New Quiz Category" :active.sync="newCategoryPopup">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" icon-pack="feather" icon="icon-book" icon-no-border label="Category Name" v-model="categoryname" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="addNewCategory">Submit</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      filter: {
        class: null,
        subject: null,
        type: null
      },
      options: {
        subjects: [],
        classes: [],
        type: [
          { type: 'classwork', label: 'Classwork' },
          { type: 'assignment', label: 'Assignment' },
          { type: 'test', label: 'Test' },
          { type: 'exam', label: 'Exam' }
        ]
      },
      openFilter: false,
      task: [],
      categoryname: null,
      newCategoryPopup: false
    }
  },
  computed: {
    subjects () {
      return this.$store.state.academics.subjects
    },
    classes () {
      return this.$store.state.academics.classes
    },
    categories () {
      return this.$store.state.academics.categories
    },
    assigned () {
      return this.$store.state.academics.assigned
    }
  },
  methods: {
    addNewCategory () {
      if (this.categoryname) {
        this.$http.post('/lms/st/task/category', { name: this.categoryname }).then((response) => {
          if (response && response.data && response.data.data) {
            // refresh category listing
            this.newCategoryPopup = false
            this.$store.dispatch('academics/fetchCategories')
          }
        }).catch((error) => { 
          console.log(error)
        })
      }
    },

    getTasks () {
      const filter = {
        class: (this.filter.class) ? this.filter.class.id : null,
        subject: (this.filter.subject) ? this.filter.subject.id : null,
        type: (this.filter.type) ? this.filter.type.type : null
      }

      this.$http.get('/lms/st/task/quiz', { params: filter }).then((response) => {
        if (response && response.data && response.data.data) {
          this.task = response.data.data
        }
      }).catch((error) => { 
        console.log(error)
      })
    }
  },
  created () {
    this.getTasks()
    if (!this.subjects) this.$store.dispatch('academics/fetchSubjects')
    if (!this.classes) this.$store.dispatch('academics/fetchClasses')
    if (!this.categories) this.$store.dispatch('academics/fetchCategories')
    if (!this.assigned) this.$store.dispatch('academics/fetchAssigned')

    if (this.assigned) {
      const tracker = { subj: {}, class: {} }
      this.assigned.forEach((v) => {
        if (!tracker.subj[v.subj_id]) {
          this.options.subjects.push({ label: v.name, id: v.subj_id })
        }

        if (!tracker.class[v.class_id]) {
          this.options.classes.push({ label: v.class_name, id: v.class_id })
        }

        tracker.subj[v.subj_id] = 1
        tracker.class[v.class_id] = 1
      })
    }
  },
  mounted () {
    this.isMounted = true
  }

}
</script>